module.exports = __webpack_public_path__ + "img/4marki.d64535ad.svg";